import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { AdaptiveLayoutState } from '@frontend/sports/layout/feature';

import { SubNavigationResolve } from '../../../sub-navigation/sub-navigation-resolve.service';

@Injectable()
export default class MyBetsDetailsSubNavigationService extends SubNavigationResolve<unknown> {
    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: unknown): void {
        this.tabs$.next([]);
    }
}
